import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { useAuth } from "../context/AuthContext";

export function AccessDeniedPage() {
  const { signOut } = useAuth();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        gap: 2,
        p: 3,
      }}
    >
      <Typography variant="h4" component="h1">
        Access Denied
      </Typography>
      <Typography variant="body1" color="text.secondary" textAlign="center">
        You need organizer or admin privileges to access this portal.
        Contact your administrator for access.
      </Typography>
      <Button variant="outlined" onClick={signOut} sx={{ mt: 2 }}>
        Sign Out
      </Button>
    </Box>
  );
}
